var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCampaignActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9923 2.32991L21.171 5.50868C22.0497 6.38736 22.0497 7.81198 21.171 8.69066L18.5866 11.2746C19.6696 11.4371 20.5 12.3714 20.5 13.4996V18.7496C20.5 19.9922 19.4926 20.9996 18.25 20.9996H4.75C3.50736 20.9996 2.5 19.9922 2.5 18.7496V5.24958C2.5 4.00693 3.50736 2.99958 4.75 2.99958H10C11.1289 2.99958 12.0637 3.83103 12.2253 4.91498L14.8103 2.32991C15.689 1.45123 17.1136 1.45123 17.9923 2.32991ZM4 18.7496C4 19.1638 4.33579 19.4996 4.75 19.4996L10.749 19.4989L10.75 12.7496L4 12.7489V18.7496ZM12.249 19.4989L18.25 19.4996C18.6642 19.4996 19 19.1638 19 18.7496V13.4996C19 13.0854 18.6642 12.7496 18.25 12.7496L12.249 12.7489V19.4989ZM10 4.49958H4.75C4.33579 4.49958 4 4.83536 4 5.24958V11.2489H10.75V5.24958C10.75 4.83536 10.4142 4.49958 10 4.49958ZM12.25 9.3089V11.2496L14.19 11.2489L12.25 9.3089Z",
    fill: "#1774B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCampaignActive);
export default __webpack_public_path__ + "static/media/my-campaign-active.261821b38da6e0d415929a9b84a717c9.svg";
export { ForwardRef as ReactComponent };